import React, { Component } from 'react';
import './App.css';
import Web3 from 'web3';
import lock from './assets/lock.png';
import BlockA from './components/BlockA';
import BlockB from './components/BlockB';
import Modal from './components/Modal';
import SubModal from './components/SubModal';

const stakingContractAddress = '0x7e9F6b7135a88c192494911Efd474dB9De2b3317';
const contractAbi = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burnFor","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"isAddress","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"contractAddress","type":"address"}],"name":"setShares","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"contractAddress","type":"address"}],"name":"setToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"sharesToken","outputs":[{"internalType":"contract SharesInterface","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"stake","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"stakingStats","outputs":[{"internalType":"uint256","name":"staked","type":"uint256"},{"internalType":"uint256","name":"rewards","type":"uint256"},{"internalType":"uint256","name":"stakingBlock","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract IBEP20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"unstake","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}];


class App extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      walletConnected : false,
      account : '',
      blockNumber : 86400,
      lockBlockNumber : 0,
      modal : false,
      status : 0,
      val : undefined,
      stacked : 0,
      available : 0
     }
     this.connectWallet = this.connectWallet.bind(this);
     this.setModal = this.setModal.bind(this);
     this.setStatus = this.setStatus.bind(this);
     this.setVal = this.setVal.bind(this);
     this.setValMax = this.setValMax.bind(this);
  }

  async connectWallet(){
    console.log("[web3] getting provider...")
    // Modern Browsers like Chrome and Brave
    if (window.ethereum) {
        try {
            // Request account access
            await window.ethereum.enable();
        } catch (error) {
            // User denied account access...
            alert('You must connect your wallet !')
            console.error("User denied account access to metamask.");
            return;
        }
    }else {
        // you cant connect
        console.error("Unable to connect to metamask");
        alert("You have to use Trustwallet app or install Metamask extension in your browser to use this app, you can install it from :  https://metamask.io/download.html");
        return;
    }

    let web3 = new Web3(window.ethereum);
    
    // Set default account 
    let accounts = await web3.eth.getAccounts();
    let account = accounts[0];
    this.setState({account : account});

    let blockNumber = await web3.eth.getBlockNumber();
    this.setState({blockNumber : blockNumber});

    // Get block of lock
    let myContract = new web3.eth.Contract(contractAbi, stakingContractAddress);
    let stats = await myContract.methods.stakingStats(account).call();
    let lockBlockNumber = stats[2];
    this.setState({lockBlockNumber :lockBlockNumber});

    this.setState({walletConnected : true});
    console.log("[web3] got provider!");
    return web3
  }

  setModal(val){
    this.setState({modal : val})
  }

  setStatus(val, stacked, available){
    this.setState({
      status : val,
      stacked : stacked,
      available: available
    })
  }

  setVal(val){
    this.setState({val:val});
  }

  setValMax(status){
    this.setState({val:(status === 1 ? this.state.available : this.state.stacked)});
  }

  async componentDidMount(){
    await this.connectWallet();
  }

  render() {

    const openPopup = (val, stacked, available) => {
      this.setStatus(val, stacked, available);
      this.setModal(true);
    };

    return ( 
      <div className='App'>
        <div className="top-section">
          {
            this.state.walletConnected ? 
            <div
            className="top-button doCenter"
            style={{
              background: "#00000015",
              height: ".8vw",
              fontSize: ".9em",
              border: "1px solid #f8d252",
            }}>
            <div
              style={{
                background: "green",
                borderRadius: "10px",
                width: "7px",
                height: "7px",
                marginRight: "10px",
              }}
            ></div>
            <span>{this.state.account.substring(0, 4)+'...'+this.state.account.substring(this.state.account.length-4, this.state.account.length)}</span>
            </div>
          :
            <div
              className="top-button doCenter"
              onClick={this.connectWallet}
            >
              <svg className="connect" viewBox="2 3 22 19.8">
                <path
                  id="connect"
                  d="M 20.70000076293945 3 C 18.88059997558594 3 17.39999961853027 4.480600357055664 17.39999961853027 6.300000190734863 C 17.39999961853027 6.807936191558838 17.52495956420898 7.283388614654541 17.73088073730469 7.713675975799561 L 13.64448928833008 11.80000019073486 L 8.398050308227539 11.80000019073486 C 7.942355155944824 10.52262496948242 6.731770992279053 9.600000381469727 5.300000667572021 9.600000381469727 C 3.480599641799927 9.600000381469727 1.999999403953552 11.08059978485107 1.999999403953552 12.89999961853027 C 1.999999403953552 14.71939945220947 3.480599641799927 16.19999694824219 5.300000667572021 16.19999694824219 C 6.731770992279053 16.19999694824219 7.942355155944824 15.27742862701416 8.398050308227539 13.99999904632568 L 13.64448928833008 13.99999904632568 L 17.73088073730469 18.08627891540527 C 17.52495956420898 18.51659965515137 17.39999961853027 18.99201965332031 17.39999961853027 19.49999809265137 C 17.39999961853027 21.31939506530762 18.88059997558594 22.79999923706055 20.70000076293945 22.79999923706055 C 22.5193977355957 22.79999923706055 24 21.31939506530762 24 19.49999809265137 C 24 17.68059921264648 22.5193977355957 16.19999694824219 20.70000076293945 16.19999694824219 C 20.19202041625977 16.19999694824219 19.71659851074219 16.3249568939209 19.28627777099609 16.53087997436523 L 15.65550804138184 12.89999961853027 L 19.28627777099609 9.26914119720459 C 19.71659851074219 9.475094795227051 20.19202041625977 9.600000381469727 20.70000076293945 9.600000381469727 C 22.5193977355957 9.600000381469727 24 8.119399070739746 24 6.300000190734863 C 24 4.480600357055664 22.5193977355957 3 20.70000076293945 3 Z"
                ></path>
              </svg>
              <span>Connect</span>
            </div>

          }

          <div className="doCenter linkage">
            <div
              className="links"
              onClick={() =>
                (window.location.href = "https://docs.apiarydao.xyz")
              }
            >
              Docs
            </div>
            <div className="seperator"></div>
            <div
              className="links"
              onClick={() => (window.location.href = "https://t.me/ApiaryDAO")}
            >
              Telegram
            </div>
            <div className="seperator"></div>
            <div
              className="links"
              onClick={() =>
                (window.location.href = "https://twitter.com/apiarydao")
              }
            >
              Twitter
            </div>
          </div>
          
          
          <div className="doCenter col">
            <div className="header">ApiaryDAO</div>
            <div
              className="links2"
              style={{ fontSize: "1.45em", marginTop: "-4px" }}
            >
              Stake APYD-BNB to earn HivePoints
            </div>

            {
            (this.state.blockNumber - this.state.lockBlockNumber > 86400) ?
            <div>
              <div
                className="block"
                style={{ fontSize: ".9em", fontWeight: "bold", marginTop: "20px" }}
              >
                <svg className="padlock" viewBox="0 0 19 19">
                  <path
                    id="padlock"
                    d="M 5.115384101867676 0 C 3.499698162078857 0 2.103818893432617 0.6708234548568726 1.233173012733459 1.758413314819336 C 0.3625302016735077 2.84600305557251 -2.026086853845754e-08 4.256160259246826 -2.026086853845754e-08 5.77764368057251 L -2.026086853845754e-08 8.03846263885498 L 2.192307949066162 8.03846263885498 L 2.192307949066162 5.77764368057251 C 2.192307949066162 4.624402523040771 2.477768182754517 3.71664834022522 2.945913314819336 3.128605604171753 C 3.414065361022949 2.540563106536865 4.050632953643799 2.192307949066162 5.115384101867676 2.192307949066162 C 6.182994365692139 2.192307949066162 6.816710472106934 2.520583868026733 7.284856796264648 3.105769157409668 C 7.753022193908691 3.690954446792603 8.03846263885498 4.610123157501221 8.03846263885498 5.77764368057251 L 8.03846263885498 6.57692289352417 L 10.23076820373535 6.57692289352417 L 10.23076820373535 5.77764368057251 C 10.23076820373535 4.24759578704834 9.845434188842773 2.823166131973267 8.974795341491699 1.735576748847961 C 8.104084968566895 0.647986888885498 6.728215217590332 0 5.115384101867676 0 Z M 6.57692289352417 7.307691097259521 C 5.366586208343506 7.307691097259521 4.384615898132324 8.289697647094727 4.384615898132324 9.5 L 4.384615898132324 16.80769348144531 C 4.384615898132324 18.01806640625 5.366586208343506 19 6.57692289352417 19 L 16.80769348144531 19 C 18.01806640625 19 19 18.01806640625 19 16.80769348144531 L 19 9.5 C 19 8.289697647094727 18.01806640625 7.307691097259521 16.80769348144531 7.307691097259521 L 6.57692289352417 7.307691097259521 Z M 11.692307472229 10.96153736114502 C 12.50017261505127 10.96153736114502 13.15384578704834 11.61521053314209 13.15384578704834 12.42307662963867 C 13.15384578704834 12.96260261535645 12.8598575592041 13.42503356933594 12.42307662963867 13.679123878479 L 12.42307662963867 15.34615325927734 C 12.42307662963867 15.7486629486084 12.09481620788574 16.07692527770996 11.692307472229 16.07692527770996 C 11.28979873657227 16.07692527770996 10.96153736114502 15.7486629486084 10.96153736114502 15.34615325927734 L 10.96153736114502 13.679123878479 C 10.52475738525391 13.42503356933594 10.23076820373535 12.96260261535645 10.23076820373535 12.42307662963867 C 10.23076820373535 11.61521053314209 10.88444137573242 10.96153736114502 11.692307472229 10.96153736114502 Z"
                  ></path>
                </svg>
                UNLOCKED - YOU CAN UNSTAKE & CLAIM REWARDS
              </div>

              <div
                className="links2"
                style={{ fontSize: "1em", fontWeight: "bold" }}
              >
                STAKING/CLAIMING RESETS TIMELOCK
              </div>
              <div className="links2" style={{ fontSize: ".9em" }}>
                86400 Blocks (- 3 Days)
              </div>
            </div>
            
            :

            <div>
              <div
                className="block"
                style={{
                  fontSize: ".9em",
                  fontWeight: "bold",
                  marginTop: "20px",
                  borderColor: "#f44336",
                  color: "#f44336",
                }}
              >
                <svg className="lock" viewBox="6 0 14 18.2">
                  <path
                    id="lock"
                    d="M 13.00000190734863 -1.324547316272628e-08 C 11.45237159729004 -1.324547316272628e-08 10.11523056030273 0.6425783038139343 9.281251907348633 1.684375166893005 C 8.447264671325684 2.726171016693115 8.100000381469727 4.076954364776611 8.100000381469727 5.534375190734863 L 8.100000381469727 6.300000667572021 L 10.20000171661377 6.300000667572021 L 10.20000171661377 5.534375190734863 C 10.20000171661377 4.429691314697266 10.47342109680176 3.560158014297485 10.92191028594971 2.996874809265137 C 11.37033081054688 2.433592319488525 11.9801025390625 2.099999904632568 13.00000190734863 2.099999904632568 C 14.02263069152832 2.099999904632568 14.62966918945313 2.414453744888306 15.07815933227539 2.974999904632568 C 15.52657985687256 3.535546064376831 15.80000114440918 4.416012763977051 15.80000114440918 5.534375190734863 L 15.80000114440918 6.300000667572021 L 17.90000152587891 6.300000667572021 L 17.90000152587891 5.534375190734863 C 17.90000152587891 4.068749904632568 17.5308895111084 2.704296112060547 16.69690895080566 1.662500143051147 C 15.86286163330078 0.6207032799720764 14.54489994049072 -1.324547316272628e-08 13.00000190734863 -1.324547316272628e-08 Z M 8.100000381469727 6.999999523162842 C 6.940624713897705 6.999999523162842 5.999999523162842 7.940659523010254 5.999999523162842 9.100000381469727 L 5.999999523162842 16.10000038146973 C 5.999999523162842 17.25940895080566 6.940624713897705 18.20000076293945 8.100000381469727 18.20000076293945 L 17.90000152587891 18.20000076293945 C 19.05941009521484 18.20000076293945 20 17.25940895080566 20 16.10000038146973 L 20 9.100000381469727 C 20 7.940659523010254 19.05941009521484 6.999999523162842 17.90000152587891 6.999999523162842 L 8.100000381469727 6.999999523162842 Z M 13.00000190734863 10.49999904632568 C 13.77384948730469 10.49999904632568 14.40000057220459 11.12615013122559 14.40000057220459 11.89999961853027 C 14.40000057220459 12.41681003570557 14.11839008331299 12.85976982116699 13.70000076293945 13.10315990447998 L 13.70000076293945 14.69999980926514 C 13.70000076293945 15.08556079864502 13.3855619430542 15.39999961853027 13.00000190734863 15.39999961853027 C 12.61444187164307 15.39999961853027 12.3000020980835 15.08556079864502 12.3000020980835 14.69999980926514 L 12.3000020980835 13.10315990447998 C 11.88161087036133 12.85976982116699 11.60000133514404 12.41681003570557 11.60000133514404 11.89999961853027 C 11.60000133514404 11.12615013122559 12.22615146636963 10.49999904632568 13.00000190734863 10.49999904632568 Z"
                  ></path>
                </svg>
                TIME UNTIL UNLOCKED - {86400 - (this.state.blockNumber - this.state.lockBlockNumber)} Blocks
              </div>

              <div
                className="links2"
                style={{ fontSize: "1em", fontWeight: "bold" }}
              >
                STAKING/CLAIMING RESETS TIMELOCK
              </div>
              <div className="links2" style={{ fontSize: ".9em" }}>
                86400 Blocks (- 3 Days)
              </div>
            </div> 
            }
          </div>
        </div>

        {this.state.walletConnected ? 
          <div className="doCenter">
            <BlockA/>
            <BlockB status={(this.state.blockNumber - this.state.lockBlockNumber > 86400)} openPopup={openPopup} val={true} />
          </div>
          :
          <div>
            <img src={lock} alt='' style={{width:'85px', marginTop:'65px'}} />
            <h2>Please Connect your wallet</h2>
          </div>
        }

        <Modal
          toggleShow={() => {
            this.setModal(!this.state.modal);
          }}
          show={this.state.modal}
        >
          <SubModal
            setModal={this.setModal}
            val={this.state.val}
            setVal={this.setVal}
            setValMax={this.setValMax}
            status={this.state.status}
            stacked={this.state.stacked}
            available={this.state.available}
          />
        </Modal>

      </div>
    );
  }
}
 
export default App;